const React = require('react');
const Card = require('@andes/card');
const { CardContent } = require('@andes/card');
const ChevronDown = require('@andes/icons/ChevronDown20');
const { getEventTracker } = require('../../../../../utils/event-tracker');

const AllCards = ({ card, lang }) => {
  const Tracker = getEventTracker();
  const isPt = lang === 'pt';

  const sendToMelidata = (data) => {
    Tracker.melidata.send('/developers/click_anchore', {
      card_name: data,
    }, {
      autoDocsRefInfo: true,
    });
  };

  function setTrack(event) {
    Tracker.send('mpdevelopers/documentation/click_anchore', event);
    sendToMelidata(event);
  }

  return (
    <a href={card?.href} target="_self" onClick={() => { setTrack(card?.track); }} aria-label={card?.label}>
      <Card className={isPt ? 'header-card-pt' : 'header-card'} shadow="elevated">
        <CardContent>
          <div className="header-card-title">
            {card?.icon}
            <span className={isPt ? 'header-card-pt-title-text' : 'header-card-title-text'}>{card?.title}</span>
          </div>
          <div className="header-card-chevron">
            <ChevronDown color="#00BCFF" />
          </div>
        </CardContent>
      </Card>
    </a>
  );
};

module.exports = AllCards;
